'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultLocales = {
  ru: {
    values: {
      "Authorization": "Авторизация",
      "Login, email, phone or user ID": "Логин, емейл, телефон или ID пользователя",
      "Choose user from list": "Выберите пользователя из списка",
      "Type confirm code": "Введите код подтверждения",
      "Type password": "Введите свой пароль",
      "Login": "Логин",
      "Email": "Емейл",
      "Phone": "Телефон",
      "Fullname": "Полное имя",
      "Password": "Пароль",
      "Signin": "Авторизоваться",
      "Signup": "Регистрация",
      "Cancel": "Отмена",
      "Reset password": "Новый пароль",
      "Code": "Код"
    }
  }
};
var AuthForm = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(AuthForm, _PrismaCmsComponent);

  function AuthForm() {
    _classCallCheck(this, AuthForm);

    return _possibleConstructorReturn(this, (AuthForm.__proto__ || Object.getPrototypeOf(AuthForm)).apply(this, arguments));
  }

  _createClass(AuthForm, [{
    key: 'renderForm',
    value: function renderForm() {
      return null;
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      return [];
    } // getSubmit() {
    // }

  }, {
    key: 'onRequestClose',
    value: function onRequestClose(event) {
      var loginCanceled = this.props.loginCanceled;
      return loginCanceled();
    }
  }, {
    key: 'cleanForm',
    value: function cleanForm() {}
  }, {
    key: 'closeForm',
    value: function closeForm() {
      var _props = this.props,
          cleanFilters = _props.cleanFilters,
          loginCanceled = _props.loginCanceled;
      this.cleanForm();
      loginCanceled();
    }
  }, {
    key: 'switchForm',
    value: function switchForm(form) {
      var switchForm = this.props.switchForm; // this.cleanForm();

      return switchForm(form);
    }
  }, {
    key: 'onAuth',
    value: function onAuth(result) {
      var _ref = result && result.data || {},
          response = _ref.response;

      var _ref2 = response || {},
          success = _ref2.success,
          message = _ref2.message,
          responseErrors = _ref2.errors,
          token = _ref2.token,
          user = _ref2.data;

      if (success && token && user) {
        var loginComplete = this.props.loginComplete;
        loginComplete({
          token: token,
          user: user
        });
      }

      this.closeForm();
      return result;
    }
  }, {
    key: 'mutate',
    value: function mutate(params) {
      var _this2 = this;

      this.setState({
        inRequest: true
      });
      return _get(AuthForm.prototype.__proto__ || Object.getPrototypeOf(AuthForm.prototype), 'mutate', this).call(this, params).then(function (result) {
        _this2.setState({
          inRequest: false
        });

        return result;
      }).catch(function (error) {
        _this2.setState({
          inRequest: false
        });

        throw error;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          fullWidth = _props2.fullWidth,
          maxWidth = _props2.maxWidth,
          dialogProps = _props2.dialogProps,
          open = _props2.open,
          other = _objectWithoutProperties(_props2, ['fullWidth', 'maxWidth', 'dialogProps', 'open']);

      return _get(AuthForm.prototype.__proto__ || Object.getPrototypeOf(AuthForm.prototype), 'render', this).call(this, _react2.default.createElement(_Dialog2.default, _extends({
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        open: open,
        onClose: function onClose(event) {
          return _this3.onRequestClose(event);
        } // onEntering={this.handleEntering}

      }, dialogProps), this.renderForm()));
    }
  }]);

  return AuthForm;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  open: _propTypes2.default.bool.isRequired,
  fullWidth: _propTypes2.default.bool,
  maxWidth: _propTypes2.default.string,
  dialogProps: _propTypes2.default.object,
  loginCanceled: _propTypes2.default.func.isRequired,
  switchForm: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  open: true,
  fullWidth: true,
  maxWidth: "xs",
  locales: defaultLocales
}), _temp);
exports.default = AuthForm;
module.exports = exports['default'];